module.exports = __webpack_public_path__ + "img/gleeder-icon.3ceaa05a.svg";